import * as React from 'react'

function SvgMl(props) {
	return (
		<svg viewBox="0 0 450 300" width="1em" height="1em" {...props}>
			<path fill="#CE1126" d="M0 0h450v300H0z" />
			<path fill="#FCD116" d="M0 0h300v300H0z" />
			<path fill="#14B53A" d="M0 0h150v300H0z" />
		</svg>
	)
}

export default SvgMl
